import { render, staticRenderFns } from "./products-in.vue?vue&type=template&id=d5657e84&scoped=true&"
import script from "./products-in.vue?vue&type=script&lang=js&"
export * from "./products-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5657e84",
  null
  
)

export default component.exports